import ConfigService from 'shared/services/config.service';

export const DepartmentsListConfig = JSON.parse(ConfigService.getConfigValue('Settings', 'Departments') || '[]') as {
  LabName: string;
  SiteId: string;
  Departments: string[];
}[];
